<template>
  <v-container fluid id="trucks" class="pa-0 pa-sm-3">
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <!-- CARD TITLE -->
        <v-card-title class="mb-0 pb-0" v-if="currentTruck">
          <h1 class="title mb-2">
            {{ currentTruck.displayName }}
            <div v-if="currentTruck.driver" class="caption">
              DRIVER:
              <strong>
                {{ currentTruck.driver.firstName }}
                {{ currentTruck.driver.lastName }}
              </strong>
            </div>
          </h1>
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-html="iframe" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row wrap justify="center">
      <v-col xs="9" class="headline pb-0"
        >Trucks
        <span v-if="trucks.length" class="caption grey--text d-block"
          >{{ trucks.length }} Trucks (* auto updated every 20 minutes)</span
        >
        <span class="caption grey--text d-block"
          >Name is what the app and reports show. Clear a name to go back to
          the NexTraq name.</span
        ></v-col
      >
      <!--  TRUCK REQUESTS -->
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-data-table
            :items="trucks"
            :headers="headers"
            :items-per-page="100"
            sort-by="hardwareId"
            sort-desc
            loading-text="Loading truck list..."
            loading="!trucks.length"
          >
            <template v-slot:item.active="{ item }">
              <v-switch
                v-model="item.active"
                dense
                hide-details
                color="success"
                class="mt-0 pt-0"
                @change="updateActive(item)"
              ></v-switch>
            </template>
            <template v-slot:item.displayName="{ item }">
              <div style="width:160px">
                <v-text-field
                  v-model="item.displayName"
                  dense
                  hide-details
                  @change="updateName(item)"
                ></v-text-field>
              </div>
            </template>
            <template v-slot:item.driver="{ item }">
              <div style="width:200px">
                <v-select
                  :items="drivers"
                  v-model="item.driver"
                  return-object
                  item-text="firstName"
                  label="Driver"
                  @change="updateAssignedTruck(item)"
                ></v-select>
              </div>
            </template>
            <template v-slot:item.address="{ item }">
              <div v-if="item.lastTrack && item.lastTrack.address">
                {{ item.lastTrack.address.street }},
                {{ item.lastTrack.address.city }}
                {{ item.lastTrack.address.state }}
              </div>
            </template>
            <template v-slot:item.lastTrack.timestamp="{ item }">
              <div v-if="item.lastTrack && item.lastTrack.timestamp">
                {{ item.lastTrack.timestamp | moment("MMM DD YYYY h:mmA") }}
              </div>
            </template>
            <template v-slot:item.details="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                @click.stop="viewLocation(item)"
                ><v-icon left small>room</v-icon>Location</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import utils from "@/helpers/utils";
export default {
  data() {
    return {
      dialog: false,
      truckLocationUrl: null,
      drivers: [],
      trucks: [],
      snack: false,
      snackColor: "",
      snackText: "",
      headers: [
        { text: "Active", value: "active", width: 90 },
        { text: "Name", value: "displayName" },
        { text: "NexTraq Name", value: "name" },
        { text: "Driver", value: "driver" },
        { text: "Last Tracked", value: "lastTrack.timestamp" },
        { text: "Last Address", value: "address" },
        { text: "View Location", align: "right", value: "details" },
      ],
      currentTruck: null,
      iframe: "<div></div>",
    };
  },
  computed: {},
  async created() {
    this.unsubscribeTrucks = await fb.db
      .collection("trucks")
      .onSnapshot((t) => {
        var trucks = [];
        t.forEach(function(doc) {
          trucks.push({
            id: doc.id,
            ...doc.data(),
            displayName: utils.truckName(doc.data()),
          });
        });
        this.trucks = trucks;
        console.log(trucks.find((t) => t.driver));
      });
    this.getDrivers();
  },
  beforeDestroy() {
    this.unsubscribeTrucks();
  },
  methods: {
    async viewLocation(item) {
      this.truckLocationUrl = null;
      this.currentTruck = item;
      if (!this.currentTruck.lastTrack || !this.currentTruck.lastTrack.address) {
        this.iframe = `<div style="padding: 20px; text-align: center; color: #888;">No location data available for this truck.</div>`;
        this.dialog = true;
        return;
      }
      const { street, city, state, zip } = this.currentTruck.lastTrack.address;
      this.truckLocationUrl =
        "https://www.google.com/maps/embed/v1/search?key=AIzaSyBOalWvMzUlY03jnN9AAJCOB3Z64szBalM&q=" +
        street +
        "+" +
        city +
        "," +
        state +
        "+" +
        zip;
      this.iframe = `<iframe
            v-if="currentTruck"
            width="100%"
            height="500"
            frameborder="0"
            style="border:0"
            src="${this.truckLocationUrl}"
            allowfullscreen
          >
          </iframe>`;
      //   this.truckLocationUrl =
      //     "https://www.google.com/maps/embed/v1/view?key=AIzaSyBOalWvMzUlY03jnN9AAJCOB3Z64szBalM&center=" +
      //     this.currentTruck.geometry.coordinates[1] +
      //     "," +
      //     this.currentTruck.geometry.coordinates[0] +
      //     "&zoom=15&maptype=roadmap";
      this.dialog = true;
    },
    async getDrivers() {
      // get tool orders
      const resDrivers = await fb.db
        .collection("users")
        .where("role", "==", "Driver")
        .get();
      let drivers = [];
      resDrivers.forEach((d) => {
        drivers.push({
          id: d.id,
          ...d.data(),
        });
      });
      this.drivers = drivers;
    },
    async updateAssignedTruck(truck) {
      try {
        await utils.assignDriver(truck.driver, truck.id);
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Driver updated successfully!";
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
    // An empty name clears friendlyName, which puts the truck back on its
    // NexTraq name.
    async updateName(item) {
      const friendlyName = `${item.displayName || ""}`.trim() || null;
      try {
        await fb.db
          .collection("trucks")
          .doc(item.id)
          .update({ friendlyName });
        item.displayName = utils.truckName({ ...item, friendlyName });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = `Truck renamed to ${item.displayName}.`;
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
    async updateActive(item) {
      try {
        await fb.db
          .collection("trucks")
          .doc(item.id)
          .update({ active: !!item.active });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = `${item.displayName || item.id} ${
          item.active ? "activated" : "deactivated"
        }.`;
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = `Error: ${error.message}`;
      }
    },
  },
};
</script>
